import React, { ChangeEvent, useId } from 'react';
import PropTypes, { InferProps } from 'prop-types';

import classnames from 'classnames/bind';

import styles from './BasicInput.module.scss';

const cx: CX = classnames.bind(styles);

function BasicInput(props: Props) {
    const {
        value, onChange, placeholder, label, maxLength,
    } = props;

    const inputId = useId();

    function handleChange(event: ChangeEvent<HTMLInputElement>) {
        onChange(event.target.value);
    }

    return (
        <div className={cx('basic-input')}>
            <label htmlFor={inputId}>
                {
                    label
                    && (
                        <div className={cx('input-label')}>
                            {label}
                        </div>
                    )
                }
                <input
                    id={inputId}
                    type="text"
                    value={value}
                    onChange={(e) => handleChange(e)}
                    placeholder={placeholder || ''}
                    maxLength={maxLength || undefined}
                    autoComplete="off"
                />
            </label>
        </div>
    );
}

BasicInput.defaultProps = {
    placeholder: '',
    label: '',
    maxLength: undefined,
};

BasicInput.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    maxLength: PropTypes.number,
};

type Props = InferProps<typeof BasicInput.propTypes>;

export default BasicInput;
